export { Button } from "./Button";
export { 
  Card, 
  CardHeader, 
  CardFooter, 
  CardTitle, 
  CardDescription, 
  CardContent 
} from "./Card";
export { Input } from "./Input";
export { Textarea } from "./Textarea";
export { Select } from "./Select";
export { Badge } from "./Badge";
export { Sheet } from "./Sheet";
export { Tabs } from "./Tabs";
export { Breadcrumbs } from "./Breadcrumbs";
export { PageHeader } from "./PageHeader";
export { Skeleton, CardSkeleton, ListSkeleton, TableSkeleton } from "./Skeleton";
export { EmptyState } from "./EmptyState";
export { RecommendationCard } from "./RecommendationCard";
export { Label } from "./Label";
export { StatusChip, ApplicationStatusChip, ResumeStatusChip, SavedJobBucketChip } from "./StatusChip";
import { useToast as useToastOriginal } from "../../react-app/contexts/ToastContext";
export { ToastProvider } from "../../react-app/contexts/ToastContext";

// Create useToastActions as an alias to useToast for backward compatibility
export function useToastActions() {
  const { showSuccess, showError, showWarning, showInfo } = useToastOriginal();
  return {
    success: showSuccess,
    error: showError,
    warning: showWarning,
    info: showInfo,
  };
}

// Re-export useToast for direct usage
export const useToast = useToastOriginal;

// Re-export existing components - commented out to fix build
// export { default as Combobox } from "./Combobox";
// export { default as Dropdown } from "./Dropdown";
// export { default as Modal } from "./Modal";
// export { default as Switch } from "./Switch";
// export { default as Tabs } from "./Tabs";